import { Directive, ElementRef } from '@angular/core';
/**
 * @hidden
 */
var ListItemDirective = /** @class */ (function () {
    function ListItemDirective(element) {
        this.element = element;
    }
    ListItemDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'li' // tslint:disable-line
                },] },
    ];
    /** @nocollapse */
    ListItemDirective.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    return ListItemDirective;
}());
export { ListItemDirective };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dropdowns/dist/es/list-item.directive.js
// module id = ../../../../@progress/kendo-angular-dropdowns/dist/es/list-item.directive.js
// module chunks = vendor